export enum LegacyAreaClassificationType {
  NotSpecified = 0,
  StandardZipCode = 1,
  UniqueZipCode = 2,
  MilitaryZipCode = 3,
  POBoxZipCode = 4,
}
